import React from 'react'

import { DescriptionContainer } from './styles'

const DescriptionSection = () => {
  return (
    <DescriptionContainer>
      <p className="description">
        Hola-ah! Para empezar a conocernos, aquí te presentamos un cuestionario
        inicial que nos servirá de guía para fijar un buen punto de partida en
        el entrenamiento que nuestro equipo Diga-ah creará para ti.
        <br />
        <br />
        Te recomendamos que te tomes un tiempo para responder este cuestionario
        con atención y conciencia, ya que cuanto más profundo te sumerjas con
        tus respuestas, mayor provecho obtendremos de la información que
        compartas en este formulario.No te preocupes si alguna pregunta te
        genera confusión; simplemente continúa y luego analizaremos tus
        respuestas juntos.
      </p>
    </DescriptionContainer>
  )
}

export default DescriptionSection
